import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IPhoneNumber } from './phoneNumber'
import { ODataService } from 'common-services'
import { IMarketChannel } from './marketChannel'

export interface IMarket extends IModelBase {
  Name: string
  MarketChannel: IMarketChannel
  IsActive: boolean
  OrganizationName: string
  OrganizationPhoneNumber: string
  OrganizationPhoneNumber1Id: number
  OrganizationPhoneNumber1: IPhoneNumber
  ProviderIds: number[]
  OperationsDirectorUserId: string
  LocationCoverageTypeId: number
  LocationCoverageDistance: number
  PeopleSoftBusinessUnit: string
}

@Injectable()
export class MarketODataService extends ODataService<IMarket> {
  constructor(protected http: HttpClient, protected config: SmODataConfiguration) {
    super(http, config)
    this.typeName = 'Markets'
  }
}
